import { forceChangePassword } from '@infuse/api/iam/user';
import { useGenericForceChangePasswordUser } from './generic/useGenericForceChangePasswordUser';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';

export const useForceChangePasswordUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericForceChangePasswordUser({
      apiFn: forceChangePassword,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericForceChangePasswordUser({
      apiFn: forceChangePassword,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericForceChangePasswordUser({
    apiFn: forceChangePassword
  });
};
